import API from '../../config/API'
import { notification } from '../../utils'
import {
  GET_ASIGN_TASKS,
  LOADING_ASIGN_TASKS,
  ERROR_ASIGN_TASKS,
  ERROR_MESSAGE,
} from './types'

export const getAssignTasks = () => async dispatch => {
  dispatch({ type: LOADING_ASIGN_TASKS })
  try {
    const tasks = []
    const {
      data: { tasks: review, success: reviewSuccess },
    } = await API.getReviewFilteredTasks()
    tasks.push(...review)
    const {
      data: { tasks: assign, success: assignSuccess },
    } = await API.getAssignFilteredTasks()
    tasks.push(...assign)
    if (assignSuccess && reviewSuccess && tasks.length > 0) {
      dispatch({
        type: GET_ASIGN_TASKS,
        tasks,
      })
    } else {
      notification({ type: `error`, message: `No se han encontrado tareas` })
      dispatch({ type: ERROR_ASIGN_TASKS })
    }
  } catch (error) {
    notification({ type: `error`, message: ERROR_MESSAGE })
    dispatch({ type: ERROR_ASIGN_TASKS })
  }
}
